export default __webpack_public_path__ + "static/media/220.978e2445.jpg";